<template>
    <div ref="dropdown" class="Dropdown" 
        @mouseenter="triggerOnHover ? open() : null" 
        @mouseleave="triggerOnHover ? close() : null">
        <div ref="trigger" class="trigger" @click="isOpen ? close() : open()">
            <slot name="trigger"/>
        </div>
        <div v-if="isOpen" class="menu" :style="{ minWidth, maxHeight }">
            <slot name="menu"/>
        </div>
    </div>
</template>


<script>
export default {
    name: 'Dropdown',

    props: {
        minWidth: { type: String, default: '180px' },
        maxHeight: { type: String, default: '200px' },
        triggerOnHover: { type: Boolean, default: false },
    },

    data: () => ({
        isOpen: false,
    }),

    beforeDestroy() {
        this.removeWindowCloseListener();
    },

    methods: {
        addWindowCloseListener() {
            window.addEventListener('click', this.onWindowClick);
        },

        removeWindowCloseListener() {
            window.removeEventListener('click', this.onWindowClick);
        },

        onWindowClick(event) {
            if (!this.$refs.trigger.contains(event.target)) {
                this.close();
            }
        },

        open() {
            this.isOpen = true;
            this.addWindowCloseListener();
        },

        close() {
            this.isOpen = false;
            this.removeWindowCloseListener();
        },
    },
};
</script>


<style lang="scss" scoped>
@import 'globals.scss';

.Dropdown {
    display: flex;
    position: relative;

    .trigger {
        display: inline-block;
        cursor: pointer;
    }

    .menu {
        position: absolute;
        z-index: $z-index-dropdown;
        top: 100%;
        right: 0;
        max-height: 150px;
        box-shadow: $shadow-medium;
        background-color: $bg-color-1;
        text-align: left;
        font-size: 14px;
        overflow-y: auto;
        border-radius: $border-radius;
        overflow-y: hidden;

        & > button,
        & > a {
            display: block;
            padding: 10px 15px;
            appearance: none;
            outline: 0;
            border: none;
            width: 100%;
            background-color: transparent;
            font-weight: $font-weight-bold;
            color: $text-color-primary;
            font-size: inherit;
            text-align: left;
            cursor: pointer;

            &:hover {
                background-color: $bg-color-3;
            }

            &.danger {
                color: $red-color;
            }

            &.link {
                color: $link-color;
            }
        }
    }
}
</style>
